import React, { FC } from "react";
import { styled } from "@mui/material";
import imgBlueCheck from "assets/image/blue-check.webp";

const BlueTick: FC<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
> = (props) => {
  return <Image {...props} src={imgBlueCheck} alt="Blue Tick" />;
};

export default BlueTick;

const Image = styled("img")({
  marginLeft: "2px",
  position: "relative",
  bottom: "-2px",
});
